import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Form, Select, Popup} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

class CampaignPart extends Component {
  constructor(props) {
    super(props);
    this.state = {'searchCampaign': false};
  }

  componentDidUpdate(prevProps) {
    const {campaignFlag, campaign, campaignId} = this.props;
    const {searchCampaign} = this.state;

    if (!campaignFlag && prevProps.campaignFlag) {
      this.props.handleChange('campaignId', 0);
      this.props.handleChange('parts', []);
      this.props.handleChange('jobs', []);
    }

    if (campaignId && searchCampaign && campaign?.campaingNo === campaignId) {
      const {partsArray} = campaign;
      const parseParts = this.parseParts(partsArray);

      this.props.handleChange('parts', parseParts);
      this.setState({'searchCampaign': false});
    }
  }

  parseParts = (parts) => {
    return parts.map((part) => {
      return {
        'id': part.partno,
        'principalPart': part?.principalPart ? 'S' : 'N',
        'fr': part.fr || ' ',
        'quantity': 0.0,
        'price': part.price || 0,
        'description': part.partName || ' ',
      };
    });
  }

  handleCampaign = (e, {value}) => {
    const {vehicle} = this.props;
    this.props.handleChange('campaignId', value);
    this.props.getCampaignById(value, {'chassis': vehicle?.chassis});
    this.setState({'searchCampaign': true});
  }

  parseCampaignOptions = () => {
    const {campaignList} = this.props;
    if (campaignList.length) {
      return campaignList.map((campaign, index) => {
        return {
          'key': index,
          'text': `${campaign.sscCode}-${campaign.campaingName}`,
          'value': campaign.campaingNo,
          'disabled': campaign.attended,
        };
      });
    }
    return [];
  }

  render() {
    const {
      campaignFlag,
      disabledBtns,
      campaignId,
      loadingCampaign,
      loading,
    } = this.props;

    if (campaignFlag) {
      return (
        <Form.Group widths='three'>
          <Form.Field
            disabled={disabledBtns || loadingCampaign}
            value={campaignId}
            control={Select}
            options={this.parseCampaignOptions()}
            label='Campaña'
            placeholder='Seleccione Campaña'
            loading={loading || loadingCampaign}
            onChange={this.handleCampaign}
            required
          />
          {campaignId !== 0 && !loadingCampaign && (
            <Form.Field className='campaign-detail-icon'>
              <Popup
                trigger={
                  <Link to={`/editar-campana/${campaignId}`} target='_blank'>
                    <span className='link'>
                      <i className='material-icons'>visibility</i>
                    </span>
                  </Link>
                }
                content='Ver Campaña'
                position='top center'
                inverted
              />
            </Form.Field>
          )}
        </Form.Group>
      );
    }
    return null;
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingCampaign': state.campaign.loading,
    'campaign': state.campaign.campaign,
    'campaignList': state.campaignList.list,
    'loading': state.campaignList.loading,
    'vehicle': state.warrantyVehicle.vehicle,
  };
};

const {
  addMessageBoxError,
  getCampaignById,
  clearCampaignsList,
  clearCampaign,
} = Actions;

export default connect(mapStateToProps, {
  addMessageBoxError,
  getCampaignById,
  clearCampaignsList,
  clearCampaign,
})(CampaignPart);
